import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {KeycloakService} from 'keycloak-angular';
import {Role} from '../../clm/types/role.enum';
import {EnvironmentService} from '../services/environment-service';

@Injectable({
  providedIn: 'root'
})
export class NormalFeatureGuard  {
  private readonly userRoles: string[];
  private readonly hasNormalPortalAccess: boolean;
  private readonly providerPortalRoles: string[] = [Role.Provider];
  private readonly onboardingPortalRoles: string[] = [Role.OnBoardingManager, Role.OnBoardingTeamLeader];
  private readonly brokerPortalRoles: string[] = [Role.Broker];

  constructor(
    private router: Router,
    private keycloakService: KeycloakService,
    private environmentService: EnvironmentService) {

    this.hasNormalPortalAccess = this.environmentService.isAllowedToAccessNormalPortal();
    this.userRoles = this.keycloakService.getUserRoles();
  }

  /**
   * This method checks if the user has access to the normal portal based on their roles.
   * If the user has access to other portals, they are redirected accordingly.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.userRoles?.length) {
      return false;
    }

    const portalRedirects = [
      {roles: this.onboardingPortalRoles, path: '/onboarding'},
      {roles: this.providerPortalRoles, path: '/provider'},
      {roles: this.brokerPortalRoles, path: '/broker'}
    ];

    for (const {roles, path} of portalRedirects) {
      if (this.hasRole(roles) || !this.hasNormalPortalAccess) {
        this.router.navigate([path]);
        return false;
      }
    }

    return true;
  }

  private hasRole(roles: string[]): boolean {
    return this.userRoles.some(userRole => roles.includes(userRole));
  }
}
